import * as React from "react";
import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales";
import { ToolTipButton } from "nsitools-react";
import assets from "../../assets";
export interface ISharepointButtonProps {
  onClick: (e) => void;
  text?: string;
  existsInShp?: boolean;
  loading?: boolean;
}

export const SharepointButton: React.FunctionComponent<ISharepointButtonProps> = ({
  onClick,
  text,
  existsInShp = true,
  loading = false,
}) => {
  const { t } = useTl();

  const tooltipText = React.useMemo(() => (existsInShp ? t(ETLCodes.GoToSharePoint) : t(ETLCodes.CreateInSharepoint)), [
    existsInShp,
    t,
  ]);

  return (
    <ToolTipButton tooltip={tooltipText} text={text} minimal onClick={onClick} loading={loading}>
      <img src={assets.images.sharepointLogo} alt="" style={{ height: "18px", width: "31px" }}/>
    </ToolTipButton>
  );
};
